export const getLocaleCurrencyMask = () => {
    let usesDotRadix: boolean = false;

    if (abp.setting.get("Core.CurrencyRadixType") === "Auto") {
        usesDotRadix = (1.1).toLocaleString(navigator.language).includes(".");
    } else if (abp.setting.get("Core.CurrencyRadixType") === ".") {
        usesDotRadix = true;
    }

    return {
        mask: Number,
        scale: 2,
        thousandsSeparator: "",
        normalizeZeros: true,
        padFractionalZeros: true,
        radix: usesDotRadix ? "." : ",",
        mapToRadix: usesDotRadix ? [","] : ["."],
    };
};
